<div class="container-fluid">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Filtres
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="form-group">
        <mat-form-field class="m-1">
          <mat-label>Connecteurs</mat-label>
          <mat-select [(value)]="filterConnector" (valueChange)="updateDataFromFilters()">
            <mat-option>Tous</mat-option>
            <mat-option value="KWFRANCE">KW France</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="m-1">
          <mat-label>Date de début</mat-label>
          <input matInput name="filterStartDateInpt" [(ngModel)]="filterStartDateInput"
            placeholder="AAAA-MM-JJ HH:mm:ss" (change)="updateDataFromFilters()"
            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}\ [0-9]{2}:[0-9]{2}:[0-9]{2}" />
          <mat-error>
            <span>Format requis : AAAA-MM-JJ HH:mm:ss</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="m-1">
          <mat-label>Date de fin</mat-label>
          <input matInput name="filterEndDateInput" [(ngModel)]="filterEndDateInput" placeholder="AAAA-MM-JJ HH:mm:ss"
            (change)="updateDataFromFilters()" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}\ [0-9]{2}:[0-9]{2}:[0-9]{2}" />
          <mat-error>
            <span>Format requis : AAAA-MM-JJ HH:mm:ss</span>
          </mat-error>
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>
    <table mat-table [dataSource]="data" multiTemplateDataRows matSort matSortActive="created" matSortDisableClear
      matSortDirection="desc">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th><!-- reactivate mat-sort-header when managed by the api-->
        <td mat-cell *matCellDef="let row" class="main">{{ row.sync.date | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Connecteur</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.sync.code }}</td>
      </ng-container>
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Utilisateur</th>
        <td mat-cell *matCellDef="let row">{{ row.user }}</td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef>ID Externe</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.sync.externalId }}</td>
      </ng-container>
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.sync.state }}</td>
      </ng-container>
      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef>Durée</th>
        <td mat-cell *matCellDef="let row"> {{ row.sync.duration/1000}}s</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button *ngIf="row.sync.error || (row.sync.details && row.sync.details.length>0)"
            (click)="expandedElement = this.expandedElement === row ? null : row" appTooltip="Voir les détails">
            <mat-icon color="primary" aria-label="Voir les détails">info_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let row">
          <div class="element-detail row" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
            <p *ngIf="row.sync.error">{{row.sync.error}}</p>
            <ul>
              <li *ngFor="let detail of row.sync.details">{{detail}}</li>
            </ul>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.expanded-row]="expandedElement === row"
        class="with-detail theme-1"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [appDetailRow]="'SELECT'"></tr>
    </table>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="paging.pagingPageSize"
    [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
</div>
